const containerCls = "_vcc15jn2v8";
const iconCls = "_vcizn3ko8";

export { containerCls, iconCls };
import "./atom.scrambled.style.linaria.module.css";
//# sourceMappingURL=atom.scrambled.style.js.map
